import { useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { EDIT_EXPERIMENT_SETTINGS_SCHEMA } from 'modules/experiments/schemas';
import { getTakeoverExperimentData } from 'modules/experiments/ducks/selectors';
import { FormSchemaType } from '../types';
import { getExperimentFormSettingDefaultValue } from '../utils';
import { useTakeoverExperimentContext } from './TakeoverExperimentContext';

export const UpdateExperimentFormProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const data = useSelector(getTakeoverExperimentData);

  const {
    sendTimeMetaInfo: { projectTimeZone },
  } = useTakeoverExperimentContext();

  const defaultValues = getExperimentFormSettingDefaultValue(data, projectTimeZone);

  const methods = useForm<FormSchemaType<typeof EDIT_EXPERIMENT_SETTINGS_SCHEMA>>({
    defaultValues,
    resolver: zodResolver(EDIT_EXPERIMENT_SETTINGS_SCHEMA),
    mode: 'all',
  });

  /**
   * Validate default values on mount.
   * This is especially done because `isDirty` is not set to true until the user interacts with the form,
   * but we want to allow users to submit the form with the default values.
   * @see https://github.com/react-hook-form/react-hook-form/issues/2755
   */
  useEffect(() => {
    methods.trigger();
  }, []);

  return <FormProvider {...methods}>{children}</FormProvider>;
};
